import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

import { store } from "./store";
import { TranslationProvider } from "./services/translations/TranslationContext";
import "./index.css";
import ScrollToTop from "./app/ScrollToTop";
import App from "./app/App";
import * as serviceWorker from "./serviceWorker";

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <TranslationProvider>
          <GoogleReCaptchaProvider reCaptchaKey="6LdX6u8UAAAAAABC54VAfYGqf62WSVroc5LCL1te">
            <ScrollToTop />
            <App />
          </GoogleReCaptchaProvider>
        </TranslationProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
